import React, { useState } from 'react'
import { Modal, Menu, Divider, Checkbox, Message } from 'semantic-ui-react'
import { useTextResources } from '../../language'

const CreateMenu = ({
  open,
  onClose,
  selectionInfo,
  createNewReservation,
  createNewMaintenance,
  createRestrictions,
  createPriceUpdate
}) => {
  const text = useTextResources()
  const defaultItem = localStorage.getItem("DefaultCalendarCreateItem")
  const [selectionAsDefault, setSelectionAsDefault] = useState(defaultItem != null)

  return (
    <Modal open={open} onClose={onClose} size="mini">
      <Modal.Header>
        {text("CreateNew")}
      </Modal.Header>
      <Modal.Content>
        <Menu vertical fluid>
          <Menu.Item link onClick={() => createNewReservation(selectionInfo, selectionAsDefault)}>
            {text("Reservation")}
          </Menu.Item>
          <Menu.Item link onClick={() => createNewMaintenance(selectionInfo, selectionAsDefault)}>
            {text("Maintenance")}
          </Menu.Item>
        </Menu>
        <Divider />
        <Menu vertical fluid secondary>
          <Menu.Item link onClick={() => createRestrictions(selectionInfo, selectionAsDefault)}>
            {text("UpdateRestrictions")}
          </Menu.Item>
          <Menu.Item link onClick={() => createPriceUpdate(selectionInfo, selectionAsDefault)}>
            {text("PricesUpdate")}
          </Menu.Item>
        </Menu>
        <Checkbox 
          checked={selectionAsDefault} 
          onChange={(e, { checked }) => setSelectionAsDefault(checked)} 
          label={text("SetSelectionAsDefault")}
        />
        {selectionAsDefault && (
          <Message info>
            {text("RevertDefaultSelectionByHoldingCtrl")}
          </Message>
        )}
      </Modal.Content>
    </Modal>
  )
}

export default CreateMenu
